(function () {
  var configEl = document.querySelector('[data-stw-config]');
  var root = document.getElementById('spin-to-win');
  if (!configEl || !root) return;

  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { config = {}; }
  var STORAGE_KEY = 'haironline_spin_result';
  var SESSION_OPEN_KEY = 'haironline_spin_autoopened';
  var SESSION_TOAST_KEY = 'haironline_spin_toasts_shown';

  // Weekly window (shop timezone): Mon 00:00 → Sat 23:59. Sunday off.
  // Liquid also gates rendering; this covers cached tabs / timezone edge cases.
  function isWithinSpinSchedule() {
    try {
      var tz = config.timeZone || 'Australia/Sydney';
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var map = {};
      for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      var dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var dow = dayMap[map.weekday];
      if (dow === undefined) return true;
      if (dow >= 1 && dow <= 5) return true;
      if (dow === 6) {
        var hm = Number(map.hour) * 100 + Number(map.minute);
        return hm <= 2359;
      }
      return false;
    } catch (e) {
      return true;
    }
  }

  if (!isWithinSpinSchedule()) {
    root.remove();
    var fabOff = document.querySelector('.stw-fab');
    if (fabOff) fabOff.remove();
    var toastOff = document.querySelector('.stw-toast');
    if (toastOff) toastOff.remove();
    return;
  }

  // Segment order must match the server-side prize list in supabase/functions/spin.
  // There is deliberately NO "$500 draw entry" segment: every participant is
  // added to the $500 draw automatically, and the winner is drawn from the
  // participants who actually made a purchase.
  var PRIZES = [
    { id: 'off10', label: '10% Off', shortLabel: '10% OFF', code: 'HALLOWEEN10', weight: 40 },
    { id: 'rpr20', label: '20% Off RPR Haircare', shortLabel: '20% OFF RPR', code: 'HALLOWEENRPR20', weight: 25 },
    { id: 'ghd15', label: '15% Off GHD Electrical Items', shortLabel: '15% OFF GHD', code: 'HALLOWEENGHD15', weight: 25 },
    { id: 'free-treatment', label: 'FREE Salon Only Magic Styling Treatment 200ml (valued at $31.95) with your Hair Online purchase', shortLabel: 'FREE TREATMENT', code: 'HALLOWEENFREEHS', weight: 10 }
  ];
  // Carnival wheel in Hair Online colours: pumpkin, mint, gold, teal.
  var COLORS = ['#e66136', '#88c3b9', '#e8a33d', '#1f6f63'];
  // White on every segment; the CSS gives labels a dark outline so they
  // stay readable on the light mint and bone segments too.
  var LABEL_COLORS = ['#ffffff', '#ffffff', '#ffffff', '#ffffff'];
  var SEGMENT = 360 / PRIZES.length;

  var lastFocused = null;
  var pendingPrize = null;
  var pendingPrizeId = null;
  var landedPrizeId = null; // segment the wheel actually stopped on — must match the result screen
  var drawPromise = null;
  var drawToken = null;
  var isSpinning = false;
  var isStopping = false;
  try {
    drawToken = sessionStorage.getItem('haironline_spin_draw_token');
    pendingPrizeId = sessionStorage.getItem('haironline_spin_prize_id');
    if (drawToken && pendingPrizeId) drawPromise = Promise.resolve(pendingPrizeId);
  } catch (e) {}

  function $(sel) { return root.querySelector(sel); }
  function showStep(name) {
    root.querySelectorAll('[data-stw-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-stw-step') !== name;
    });
    var dialog = root.querySelector('.stw__dialog');
    if (dialog) dialog.scrollTop = 0;
  }
  function storedResult() {
    try { var raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }
  function storeResult(prize) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(prize)); } catch (e) {}
  }
  function buildWheel() {
    var group = root.querySelector('[data-stw-segments]');
    if (!group) return;
    var svgNS = 'http://www.w3.org/2000/svg';
    PRIZES.forEach(function (prize, i) {
      var start = (i * SEGMENT - 90) * Math.PI / 180;
      var end = ((i + 1) * SEGMENT - 90) * Math.PI / 180;
      var x1 = 160 + 148 * Math.cos(start), y1 = 160 + 148 * Math.sin(start);
      var x2 = 160 + 148 * Math.cos(end), y2 = 160 + 148 * Math.sin(end);
      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', 'M160 160 L' + x1.toFixed(1) + ' ' + y1.toFixed(1) + ' A148 148 0 0 1 ' + x2.toFixed(1) + ' ' + y2.toFixed(1) + ' Z');
      path.setAttribute('fill', COLORS[i]);
      path.setAttribute('stroke', '#17110d');
      path.setAttribute('stroke-width', '3');
      group.appendChild(path);

      var mid = (i * SEGMENT + SEGMENT / 2 - 90) * Math.PI / 180;
      var tx = 160 + 103 * Math.cos(mid), ty = 160 + 103 * Math.sin(mid);
      var text = document.createElementNS(svgNS, 'text');
      text.setAttribute('x', tx.toFixed(1));
      text.setAttribute('y', ty.toFixed(1));
      text.setAttribute('text-anchor', 'middle');
      text.setAttribute('fill', LABEL_COLORS[i]);
      text.setAttribute('class', 'stw__wheel-label');
      text.setAttribute('transform', 'rotate(' + (i * SEGMENT + SEGMENT / 2) + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ')');
      text.textContent = prize.shortLabel;
      group.appendChild(text);
    });
  }

  function openModal() {
    lastFocused = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    var existing = storedResult();
    if (existing) { renderResult(existing, true); } else { showStep('entry'); }
    var focusTarget = root.querySelector('[data-stw-step]:not([hidden]) input, [data-stw-step]:not([hidden]) button, .stw__close');
    if (focusTarget) focusTarget.focus();
  }
  function closeModal() {
    root.hidden = true;
    document.body.style.overflow = '';
    isSpinning = false;
    isStopping = false;
    var wheel = $('[data-stw-wheel]');
    if (wheel) wheel.classList.remove('is-spinning');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function clearDrawSession() {
    drawToken = null;
    pendingPrizeId = null;
    landedPrizeId = null;
    drawPromise = null;
    pendingPrize = null;
    try {
      sessionStorage.removeItem('haironline_spin_draw_token');
      sessionStorage.removeItem('haironline_spin_prize_id');
    } catch (e) {}
  }

  // Halloween confetti — flat pumpkin / mint / bone / bark pieces burst over
  // the dialog on a fresh win. No library; canvas is removed when it settles.
  function fireConfetti() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvas = $('[data-stw-confetti]');
    var dialog = root.querySelector('.stw__dialog');
    if (!canvas || !dialog) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = dialog.clientWidth;
    canvas.height = dialog.clientHeight;
    var colors = ['#e66136', '#e8a33d', '#88c3b9', '#fff3e2'];
    var pieces = [];
    for (var i = 0; i < 150; i++) {
      pieces.push({
        x: canvas.width / 2 + (Math.random() - 0.5) * 180,
        y: canvas.height * 0.38,
        vx: (Math.random() - 0.5) * 11,
        vy: -(Math.random() * 10 + 5),
        w: Math.random() * 8 + 5,
        h: Math.random() * 5 + 3,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: colors[i % colors.length],
        circle: Math.random() < 0.3
      });
    }
    var started = performance.now();
    (function frame(now) {
      var elapsed = now - started;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach(function (p) {
        p.vy += 0.22; p.x += p.vx; p.y += p.vy; p.vx *= 0.99; p.rot += p.vr;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, 1 - elapsed / 3200);
        ctx.fillStyle = p.color;
        if (p.circle) { ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2); ctx.fill(); }
        else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.sin(p.rot * 2)) + 1);
        ctx.restore();
      });
      if (elapsed < 3200) requestAnimationFrame(frame);
      else ctx.clearRect(0, 0, canvas.width, canvas.height);
    })(started);
  }

  function renderResult(prize, alreadySpun, emailSent) {
    showStep('result');
    $('[data-stw-already]').hidden = !alreadySpun;
    var resultTitle = $('[data-stw-result-title]');
    resultTitle.textContent = alreadySpun ? 'Your treat is waiting' : 'You won!!';
    resultTitle.classList.toggle('stw__title--small', !!alreadySpun);
    $('[data-stw-prize-label]').textContent = prize.label;
    var note = $('[data-stw-prize-note]');
    var codebox = $('[data-stw-codebox]');
    var claim = $('[data-stw-claim]');
    var claimNote = $('[data-stw-claim-note]');
    var emailNote = $('[data-stw-email-note]');
    var shop = $('[data-stw-shop]');
    var drawStatus = $('[data-stw-draw-status]');
    // Belt and braces: the free-treatment button must ONLY ever appear for
    // free-treatment winners. `hidden` alone has bitten us before (the
    // .stw__cta display:block can win in some cached/old CSS), so set the
    // inline display too and re-assert it in the branch below.
    claim.hidden = true;
    claim.style.display = 'none';
    if (claimNote) { claimNote.hidden = true; }
    if (emailNote) {
      emailNote.hidden = !(emailSent && !alreadySpun);
      if (!emailNote.hidden) emailNote.textContent = 'We’ve also emailed this to you — prize, code and all — so you can find it later.';
    }
    if (prize.id === 'draw500') {
      // Legacy (pre-change) stored result: that segment no longer exists.
      codebox.hidden = true;
      if (drawStatus) drawStatus.hidden = true;
      note.textContent = 'You are on the $500 voucher draw list. Make a Hair Online purchase and you are in the final draw — we will email the winner after the campaign ends.';
      shop.setAttribute('href', '/');
      shop.innerHTML = 'Shop now <span aria-hidden="true">→</span>';
    } else {
      codebox.hidden = false;
      if (drawStatus) drawStatus.hidden = false;
      $('[data-stw-code]').textContent = prize.code || '';
      note.textContent = prize.id === 'free-treatment'
        ? 'Your FREE Salon Only Magic Styling Treatment 200ml (valued at $31.95) comes with your Hair Online purchase. Add it below and your code will be applied.'
        : 'Use this code at checkout. One use per customer.';
      // Absolute shop URL: /discount/ links 401 through the theme-dev proxy
      // (127.0.0.1:9292), so send shoppers to the real domain where Shopify
      // can set the discount cookie and redirect to the homepage.
      shop.setAttribute('href', (config.shopUrl || '') + '/discount/' + encodeURIComponent(prize.code || ''));
      shop.innerHTML = 'Shop now <span aria-hidden="true">→</span>';
      if (prize.id === 'free-treatment' && config.freeProductVariantId) {
        claim.hidden = false;
        claim.style.display = '';
        if (claimNote) claimNote.hidden = false;
      }
    }
    if (!alreadySpun) fireConfetti();
  }

  function pickLocalPrize() {
    var total = PRIZES.reduce(function (s, p) { return s + p.weight; }, 0);
    var roll = Math.random() * total, prize = PRIZES[0];
    for (var i = 0; i < PRIZES.length; i++) { roll -= PRIZES[i].weight; if (roll < 0) { prize = PRIZES[i]; break; } }
    return { id: prize.id, label: prize.label, shortLabel: prize.shortLabel, code: prize.code, inDraw: true };
  }

  function supabaseHeaders() {
    return { 'Content-Type': 'application/json', 'apikey': config.anonKey, 'Authorization': 'Bearer ' + config.anonKey };
  }

  // The prize is drawn server-side the moment "Spin now" is pressed. The
  // draw endpoint returns an opaque token (authoritative — the claim call
  // redeems whatever the server stored against it, so the prize can never
  // be changed or re-rolled in the browser) plus the prize *id*, which is
  // used for one thing only: landing the wheel on the segment that was
  // actually drawn. The code/label stay server-side until claiming.
  // Returns a promise resolving to { token, prizeId } (prizeId may be null
  // on older backends that haven't been redeployed yet).
  function requestDraw(force) {
    if (!config.supabaseUrl || !config.anonKey) {
      if (!pendingPrize) { pendingPrize = pickLocalPrize(); pendingPrizeId = pendingPrize.id; }
      drawPromise = Promise.resolve({ token: null, prizeId: pendingPrizeId });
      return drawPromise;
    }
    if (drawPromise && !force) return drawPromise;
    // Never force-redraw when we already hold a token — that would mint a
    // second prize and desync the wheel from the claim result.
    if (force && drawToken) {
      drawPromise = Promise.resolve({ token: drawToken, prizeId: pendingPrizeId });
      return drawPromise;
    }
    if (force) { drawToken = null; pendingPrizeId = null; }
    drawPromise = fetch(config.supabaseUrl.replace(/\/$/, '') + '/functions/v1/draw', {
      method: 'POST', headers: supabaseHeaders(), body: '{}'
    }).then(function (res) { return res.json(); }).then(function (data) {
      if (data && data.token) {
        drawToken = data.token;
        pendingPrizeId = data.prizeId || null;
        try {
          sessionStorage.setItem('haironline_spin_draw_token', drawToken);
          if (pendingPrizeId) sessionStorage.setItem('haironline_spin_prize_id', pendingPrizeId);
          else sessionStorage.removeItem('haironline_spin_prize_id');
        } catch (e) {}
        return { token: drawToken, prizeId: pendingPrizeId };
      }
      return { token: null, prizeId: null };
    }).catch(function () { return { token: null, prizeId: null }; });
    return drawPromise;
  }

  function prizeIndex(prizeId) {
    for (var i = 0; i < PRIZES.length; i++) { if (PRIZES[i].id === prizeId) return i; }
    return -1;
  }

  // Rotation (deg, clockwise) that puts segment `index` under the top
  // pointer. Segments are drawn from -90deg (top) in SEGMENT steps and the
  // segment mid sits at index*SEGMENT - 45deg, so the wheel must finish at
  // 315 - index*SEGMENT (plus a small in-segment jitter so it doesn't land
  // dead-centre every time). Keep in sync with buildWheel().
  function targetRotationFor(index) {
    var jitter = Math.floor(Math.random() * 41) - 20; // ±20deg, mid is ±45
    return ((315 - index * SEGMENT + jitter) % 360 + 360) % 360;
  }

  // Animate the wheel onto a known prize. Resolves when the deceleration
  // finishes. Never call this with a guessed/random index — only with the
  // prize id that will be shown on the result screen.
  function landWheelOnPrize(prizeId) {
    return new Promise(function (resolve) {
      var index = prizeIndex(prizeId);
      if (index < 0) { resolve(false); return; }
      landedPrizeId = prizeId;
      var wheel = $('[data-stw-wheel]');
      if (!wheel) { resolve(true); return; }
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var angle = 0;
      var matrix = window.getComputedStyle(wheel).transform;
      if (matrix && matrix !== 'none') {
        var values = matrix.match(/-?[\d.]+/g);
        if (values && values.length >= 2) angle = Math.atan2(parseFloat(values[1]), parseFloat(values[0])) * 180 / Math.PI;
      }
      angle = ((angle % 360) + 360) % 360;
      wheel.classList.remove('is-spinning');
      wheel.style.transform = 'rotate(' + angle + 'deg)';
      void wheel.offsetWidth;
      var target = targetRotationFor(index);
      var delta = ((target - angle) % 360 + 360) % 360 + 720;
      wheel.style.transition = reduced ? 'transform .3s ease-out' : 'transform 2.6s cubic-bezier(.12,.65,.08,1)';
      wheel.style.transform = 'rotate(' + (angle + delta) + 'deg)';
      setTimeout(function () { resolve(true); }, reduced ? 350 : 2750);
    });
  }

  // Freeze the free-spin without committing to a segment — used when the
  // backend hasn't told us the prize id yet. The real land happens after claim.
  function freezeWheel() {
    var wheel = $('[data-stw-wheel]');
    if (!wheel) return;
    var angle = 0;
    var matrix = window.getComputedStyle(wheel).transform;
    if (matrix && matrix !== 'none') {
      var values = matrix.match(/-?[\d.]+/g);
      if (values && values.length >= 2) angle = Math.atan2(parseFloat(values[1]), parseFloat(values[0])) * 180 / Math.PI;
    }
    wheel.classList.remove('is-spinning');
    wheel.style.transition = 'none';
    wheel.style.transform = 'rotate(' + angle + 'deg)';
  }

  function goToClaimForm() {
    showStep('claim');
    var firstInput = root.querySelector('[data-stw-form] input[name="firstName"]');
    if (firstInput) firstInput.focus();
  }

  function requestClaim(entry) {
    if (!config.supabaseUrl || !config.anonKey) {
      return new Promise(function (resolve) {
        setTimeout(function () { resolve({ alreadySpun: false, prize: pendingPrize || pickLocalPrize() }); }, 350);
      });
    }
    var body = Object.assign({}, entry, { drawToken: drawToken || '' });
    return fetch(config.supabaseUrl.replace(/\/$/, '') + '/functions/v1/spin', {
      method: 'POST', headers: supabaseHeaders(), body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
        return data;
      });
    });
  }

  function startSpinning() {
    showStep('wheel');
    landedPrizeId = null;
    requestDraw();
    var wheel = $('[data-stw-wheel]');
    var stopBtn = $('[data-stw-stop]');
    stopBtn.disabled = false; stopBtn.textContent = 'Stop the cauldron';
    isSpinning = true;
    isStopping = false;
    wheel.style.transition = 'none';
    wheel.style.transform = '';
    wheel.classList.add('is-spinning');
    stopBtn.focus();
  }

  function stopSpinning() {
    if (!isSpinning || isStopping) return;
    isStopping = true;
    var stopBtn = $('[data-stw-stop]');
    stopBtn.disabled = true; stopBtn.textContent = 'Locking in your prize…';
    // NEVER land on a random segment. The wheel must stop on the same prize
    // the result screen will show. Prefer the prize id from the draw call;
    // if the backend hasn't returned one yet (older deploy), freeze the
    // wheel and land it for real after the claim reveals the prize.
    Promise.resolve(requestDraw()).then(function (draw) {
      if ((!draw || !draw.token) && config.supabaseUrl && config.anonKey) {
        return requestDraw(true);
      }
      return draw;
    }).then(function (draw) {
      var prizeId = (draw && draw.prizeId) || pendingPrizeId || (pendingPrize && pendingPrize.id) || null;
      isSpinning = false;
      isStopping = false;
      if (prizeId && prizeIndex(prizeId) >= 0) {
        return landWheelOnPrize(prizeId).then(function () { goToClaimForm(); });
      }
      // Prize id unknown — freeze in place. We'll land after claim.
      freezeWheel();
      goToClaimForm();
    }).catch(function () {
      isSpinning = false;
      isStopping = false;
      freezeWheel();
      goToClaimForm();
    });
  }

  // Winner chips — bottom-left toast only (no in-popup winners list).
  // Shows recent winners who consented to be named, max 3 per session.
  function timeAgo(iso) {
    var seconds = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
    if (seconds < 90) return 'just now';
    var minutes = Math.floor(seconds / 60);
    if (minutes < 60) return minutes + ' min ago';
    var hours = Math.floor(minutes / 60);
    if (hours < 24) return hours + (hours === 1 ? ' hr ago' : ' hrs ago');
    return Math.floor(hours / 24) + 'd ago';
  }
  var toastTimer = null;
  function startToasts(winners) {
    var toast = document.querySelector('[data-stw-toast]');
    if (!toast || !winners.length) return;
    var shown = 0;
    try { shown = Number(sessionStorage.getItem(SESSION_TOAST_KEY) || 0); } catch (e) {}
    if (shown >= 3) return;
    var index = 0;
    function tick() {
      if (index >= winners.length || shown >= 3) { toast.hidden = true; return; }
      // Wait until the spin popup is closed so the chip isn't behind it.
      if (!root.hidden) { toastTimer = setTimeout(tick, 4000); return; }
      toast.querySelector('[data-stw-toast-text]').textContent = winners[index].firstName + ' just won ' + winners[index].prizeLabel + '! · ' + timeAgo(winners[index].createdAt);
      toast.hidden = false;
      shown++; index++;
      try { sessionStorage.setItem(SESSION_TOAST_KEY, String(shown)); } catch (e) {}
      setTimeout(function () { toast.hidden = true; toastTimer = setTimeout(tick, 7000); }, 6000);
    }
    toastTimer = setTimeout(tick, 2500);
    toast.querySelector('[data-stw-toast-close]').addEventListener('click', function () {
      toast.hidden = true; if (toastTimer) clearTimeout(toastTimer);
      try { sessionStorage.setItem(SESSION_TOAST_KEY, '3'); } catch (e) {}
    });
  }
  function loadWinnerChips() {
    if (!config.supabaseUrl || !config.anonKey) return;
    fetch(config.supabaseUrl.replace(/\/$/, '') + '/functions/v1/winners', {
      headers: { 'apikey': config.anonKey, 'Authorization': 'Bearer ' + config.anonKey }
    }).then(function (res) { return res.json(); }).then(function (data) {
      startToasts((data && data.winners) || []);
    }).catch(function () {});
  }

  buildWheel();

  document.querySelectorAll('[data-spin-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
  });
  root.querySelectorAll('[data-stw-close]').forEach(function (btn) { btn.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') closeModal();
    // Space spins / stops, like the reference game — unless typing in a field.
    if ((e.key === ' ' || e.key === 'Spacebar') && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) {
      var entryStep = root.querySelector('[data-stw-step="entry"]:not([hidden])');
      var wheelStep = root.querySelector('[data-stw-step="wheel"]:not([hidden])');
      if (entryStep) { e.preventDefault(); $('[data-stw-start]').click(); }
      else if (wheelStep && isSpinning) { e.preventDefault(); stopSpinning(); }
    }
    if (e.key === 'Tab') {
      var focusables = Array.prototype.slice.call(root.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"])')).filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  $('[data-stw-start]').addEventListener('click', function () {
    var existing = storedResult();
    if (existing) { renderResult(existing, true); return; }
    startSpinning();
  });

  $('[data-stw-stop]').addEventListener('click', stopSpinning);

  var form = $('[data-stw-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var error = $('[data-stw-error]');
    var firstName = form.firstName.value.trim();
    var email = form.email.value.trim();
    if (!firstName) { error.textContent = 'Please enter your first name.'; error.hidden = false; return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { error.textContent = 'Please enter a valid email address.'; error.hidden = false; return; }
    error.hidden = true;
    var existing = storedResult();
    if (existing) { renderResult(existing, true); return; }
    var submitBtn = $('[data-stw-submit]');
    submitBtn.disabled = true; submitBtn.textContent = 'Revealing your code…';
    requestClaim({
      firstName: firstName, email: email,
      consentToPublish: form.consentToPublish.checked,
      marketingOptIn: form.marketingOptIn.checked,
      website: form.website.value
    }).then(function (data) {
      storeResult(data.prize);
      // Capture before clearDrawSession() wipes landedPrizeId.
      var wonId = data.prize && data.prize.id;
      var alreadyOnPrize = !!(wonId && landedPrizeId === wonId);
      clearDrawSession();
      // Guarantee: the segment under the pointer matches the prize shown.
      // If we already landed on this prize during stop, skip straight to
      // the result. If we froze without knowing the prize (or somehow
      // landed on the wrong one), land now before revealing.
      var finish = function () {
        submitBtn.disabled = false; submitBtn.textContent = 'Accept & reveal my code';
        renderResult(data.prize, data.alreadySpun, data.emailSent);
      };
      if (alreadyOnPrize || data.alreadySpun || !wonId) {
        finish();
        return;
      }
      submitBtn.textContent = 'Landing your treat…';
      showStep('wheel');
      landWheelOnPrize(wonId).then(finish).catch(finish);
    }).catch(function (err) {
      submitBtn.disabled = false; submitBtn.textContent = 'Accept & reveal my code';
      error.textContent = err.message || 'Something went wrong. Please try again.';
      error.hidden = false;
    });
  });

  var copyBtn = $('[data-stw-copy]');
  copyBtn.addEventListener('click', function () {
    var code = $('[data-stw-code]').textContent;
    function done() { copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done).catch(done); else done();
  });

  $('[data-stw-claim]').addEventListener('click', function () {
    // Safety net: this button is only for free-treatment winners. Never add
    // the treatment to the cart for any other prize, even if it gets clicked.
    var result = storedResult();
    if (!result || result.id !== 'free-treatment') return;
    var btn = this; btn.disabled = true; btn.textContent = 'Adding your free treatment…';
    var variantId = Number(config.freeProductVariantId);
    var code = result.code || 'HALLOWEENFREEHS';
    // The treatment is a full-price product in the catalogue — it only
    // becomes $0 when the HALLOWEENFREEHS discount (Shopify Admin >
    // Discounts) is active, and Shopify applies that discount at checkout,
    // not in the cart AJAX response. So: add it once (never duplicate it),
    // fail loudly if Shopify rejects the add instead of silently leaving a
    // paid item behind, then apply the code via /discount/<code>, which
    // sets the discount and takes the customer on to shop/check out.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var alreadyInCart = (cart.items || []).some(function (item) { return Number(item.variant_id) === variantId; });
        if (alreadyInCart) return { ok: true };
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { 'Spin to Win': 'Free treatment' } }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        });
      })
      .then(function () { window.location.href = (config.shopUrl || '') + '/discount/' + encodeURIComponent(code); })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Add my free treatment & apply code';
        var claimNote = $('[data-stw-claim-note]');
        if (claimNote) {
          claimNote.hidden = false;
          claimNote.textContent = 'Sorry — we couldn’t add the treatment just now. Please try again, or add the Salon Only Magic Styling Treatment 200ml to your cart yourself and use code ' + code + ' at checkout.';
        }
      });
  });

  window.HairOnlineSpinToWin = { open: openModal, close: closeModal };

  if (config.autoOpen) {
    var alreadyAutoOpened = false;
    try { alreadyAutoOpened = sessionStorage.getItem(SESSION_OPEN_KEY) === 'true'; } catch (e) {}
    if (!alreadyAutoOpened) {
      setTimeout(function () {
        if (storedResult()) return;
        try { sessionStorage.setItem(SESSION_OPEN_KEY, 'true'); } catch (e) {}
        openModal();
      }, config.autoOpenDelayMs || 3000);
    }
    if (!storedResult()) loadWinnerChips();
  }
})();
